// events/consentUpdateEvent.ts

import { ConsentUpdate } from '../consent/consentManager';

export const CONSENT_UPDATE_EVENT = 'consentUpdate';

export interface ConsentUpdateEventDetail {
	consentUpdates: ConsentUpdate[];
}

/**
 * Dispatches a consent update event.
 *
 * @param {ConsentUpdate[]} consentUpdates - The consent updates to apply.
 */
export function dispatchConsentUpdate(consentUpdates: ConsentUpdate[]): void {
	document.dispatchEvent(
		new CustomEvent<ConsentUpdateEventDetail>(CONSENT_UPDATE_EVENT, {
			detail: { consentUpdates },
		}),
	);
}
